/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens.
 */
(function () {

    const toggle_button = document.querySelector(".mobile-menu__button");

    toggle_button.addEventListener("click", toggle_mobile_menu);

    set_tabindex(document.querySelectorAll(".mobile-menu a"), -1);


})();

function toggle_mobile_menu() {

    const is_expanded = this.getAttribute("aria-expanded") === "true";

    if (is_expanded) {
        this.setAttribute("aria-expanded", false);
        set_tabindex(document.querySelectorAll(".mobile-menu a"), -1);
    } else {
        this.setAttribute("aria-expanded", true);
        set_tabindex(document.querySelectorAll(".mobile-menu a"), 0);
    }


}

function set_tabindex($elements, $tabindex_value) {

    for (const $element of $elements) {

        $element.setAttribute("tabindex", $tabindex_value);

    }


}
